module.exports = __webpack_public_path__ + "static/media/img7.769bf6f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Galeria/about/img7.jpg
// module id = 90
// module chunks = 0